import type { DependencyContainer } from 'tsyringe';
import { ICategorySuggestionEngineToken } from './CategorySuggestionEngine';
import { BffCategorySuggestionEngine } from './BffCategorySuggestionEngine';

/**
 * Binds the category suggestion engine to the BFF-backed implementation. Swap
 * the bound class to retarget the assist without touching the view model.
 */
export function registerCategorySuggestionEngine(container: DependencyContainer): void {
    container.register(ICategorySuggestionEngineToken, { useClass: BffCategorySuggestionEngine });
}
